import React, { Fragment } from 'react';
import ReactDatatable from '@ashvin27/react-datatable';
import axios from 'axios';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { baseURL } from '../../_helpers';
import { Link } from 'react-router-dom';
import * as moment from 'moment';
import { TOKEN } from '../../_helpers/token';
import Modal from 'react-modal';
import './style.css';
import { MDBCloseIcon } from "mdbreact"
import Select from 'react-select';
import '../users/style.css'




export class UserDetailsLudoExpress extends React.Component {
    constructor(props) {
        super(props);
        this.toggleModalCreate = this.toggleModalCreate.bind(this);

        this.columns = [

            {
                key: "total_bets",
                TrOnlyClassName: 'tsc',
                text: "Total Stake",
                className: "tsc",
                align: "left"
            },
            {
                key: "total_wins",
                TrOnlyClassName: 'tsc',
                text: "Total Wins",
                className: "tsc",
                align: "left"
            },
            {
                key: "mtimeCreated",
                TrOnlyClassName: 'tsc',
                text: "Date Join",
                className: "tsc",
                align: "left"
            },

            {
                key: "dates2",
                TrOnlyClassName: 'tsc',
                text: "Last Date Active",
                className: "tsc",
                align: "left"
            },


        ];




        this.columns3 = [
            {
                key: "reference",
                TrOnlyClassName: 'tsc',
                text: "gameID",
                className: "tsc",
                align: "left"
            },

            {
                key: "transaction_id",
                TrOnlyClassName: 'tsc',
                text: "TransactionID",
                className: "tsc",
                align: "left"
            },
            {
                key: "stake_amount",
                TrOnlyClassName: 'tsc',
                text: "Stake",
                className: "tssc",
                align: "left"
            },
            {
                key: "dates",
                TrOnlyClassName: 'tsc',
                text: "TimeStamp",
                className: "tsc",
                align: "left"
            },

        ];
        this.config = {
            key_column: "tsc",
            length_menu: [10, 20, 50],
            show_filter: false,
            show_pagination: false,
            pagination: 'basic',
            page_size: 10,
            show_info: false,
            show_length_menu: false,
            language: {
                loading_text: "Please be patient while data loads..."
            }
        }
        this.state = {
            admins: [],
            isLoading: true,
            showModal: false,
            showError: false,
            isShowError: false,
            showComponent: false,
            hideComponent: false,
            data: [],
            ddata: [],
            oncall: true,
            call_status: "On Call",
            remarks: "Pending",
            isOpen: false,
            isOpenModel: false,
            call_value: [
                { value: 'On Call', label: 'On Call' }],

            remark_value: [

                { value: 'Pending', label: 'Pending' }],

        };
    }

    toggleModalCreate = e => {
        this.setState({
            isOpen: true,
        });
    };

    closeModalUpload = e => {
        this.setState({
            isOpen: false,
        });
    };


    getData = () => {
        this.setState({
            isLoading: true,
        })
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "Authorization": TOKEN
            }
        };

        let url = baseURL + "ludo_deposit_all?msisdn=" + localStorage.getItem("phone")
        // alert(url)
        axios.get(url, axiosConfig, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        })
            .then((branchResponse) => {
                this.setState({
                    adminss: branchResponse.data,
                    isLoading: false,
                }, function () {
                    // alert(JSON.stringify(branchResponse.data))
                    var data = [];
                    if (this.state.adminss.length > 0) {
                        for (let i = 0; i < this.state.adminss.length; i++) {
                            let date = { dates: moment(this.state.adminss[i].last_play_time).utc().format("DD-MMM-yyyy HH:mm:ss") };
                            let mlive = { mlive: this.state.adminss[i].game }
                            if (this.state.adminss[i].game == 'Live') {
                                mlive = { mlive: "PowerBox Live" };
                            }
                            data.push(Object.assign(date, mlive, this.state.adminss[i]));
                            this.setState({
                                ddata: data
                            })
                        }
                    } else {
                        this.setState({
                            ddata: data
                        })
                    }


                }
                );
            })
    }


    componentDidMount() {

        this.getData()
        this.setState({ isLoading: true });
        axios.get(baseURL + 'customersoneludo/' + localStorage.getItem("phone"), {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
        })
            .then((response) => {
                console.log("bayo", response.data)
                this.setState({
                    admins: response.data.data,
                    isLoading: false
                },
                    function () {


                        var data = [];
                        for (let i = 0; i < this.state.admins.length; i++) {
                            let mbalance;



                            localStorage.setItem('customerID', this.state.admins[i].id)

                            let dates = { dates2: moment(this.state.admins[i].last_stake_time).format('DD MMM, YYYY HH:MM') };


                            let mtimeCreated = { mtimeCreated: moment(this.state.admins[i].date_created).format('DD MMM, YYYY HH:MM') };




                            data.push(Object.assign(mtimeCreated, mbalance, dates, this.state.admins[i]));
                            this.setState({
                                data: data,
                                number: this.state.admins[i].msisdn
                            })
                        }

                    }
                );
            })


    }



    handleChange = value => {
        if (value != null) {

            this.setState(
                {
                    // ...this.state.editedInvoice,
                    call_status: value.value.toString(),
                    call_value: [
                        { value: value.value.toString(), label: value.value.toString() }],

                    // customer_name: value.label.toString(),
                    // customer_nameinvoice2: value.customer_nameinvoice.toString(),
                    // customer_email: value.customer_email.toString(),
                });
        }
    };

    handleChangeMessage = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }


    handleChangeRemarks = value => {
        if (value != null) {

            this.setState(
                {
                    // ...this.state.editedInvoice,
                    remarks: value.value.toString(),
                    remark_value: [

                        { value: value.value.toString(), label: value.value.toString() }],

                    // customer_name: value.label.toString(),
                    // customer_nameinvoice2: value.customer_nameinvoice.toString(),
                    // customer_email: value.customer_email.toString(),
                });
        }
    };

    handleChangeCallType = value => {
        if (value != null) {

            this.setState(
                {
                    // ...this.state.editedInvoice,
                    call_type: value.value.toString(),
                    call_type_value: [

                        { value: value.value.toString(), label: value.value.toString() }],

                    // customer_name: value.label.toString(),
                    // customer_nameinvoice2: value.customer_nameinvoice.toString(),
                    // customer_email: value.customer_email.toString(),
                });
        }
    };


    render() {
        // console.log("Load", isLoading);
        return (
            <div>
                <>
                    <Col md={12}>
                        <h4>LudoExpress <b>{localStorage.getItem("phone")}</b></h4><br />

                    </Col>
                    < Col md={12} lg={12} >
                        < Card >
                            <CardBody >
                                <div className="panel-body" >
                                    <Link to="/user_search_ludo">
                                        <Button className="pull-right"
                                            color="primary" outline>Go Back</Button><br /> <br /><br />
                                    </Link>
                                    {this.state.isShowError ?
                                        <div className="alert alert-success" >
                                            {this.state.statusMessage}
                                        </div> : null
                                    }
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="col-md-8 offset-md-2">

                                                <Link to="/user_details_ludo_withdrawal">
                                                    <Button className=""
                                                        color="primary" outline> PayOuts </Button><br /> <br /><br />
                                                </Link>
                                                <Link to="/all_message_all_ludo">
                                                    <Button className=""
                                                        color="primary" outline>Messages </Button><br /> <br /><br />
                                                </Link>
                                            </div>
                                        </div>

                                        <div className="col-md-8">

                                            < ReactDatatable config={this.config}
                                                records={this.state.data}
                                                id="tsc"
                                                columns={this.columns}
                                                loading={this.state.isLoading}
                                                extraButtons={this.extraButtons}
                                            />

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <h4><b>Last 10 Games</b></h4>
                                                </div>
                                                <div className="col-md-6">

                                                    <Link to="/user_details_ludo_deposit">
                                                        <Button className=""
                                                            color="primary" outline>More </Button><br /> <br /><br />
                                                    </Link>
                                                </div>
                                            </div>
                                            < ReactDatatable config={this.config}
                                                records={this.state.ddata}
                                                id="tsc"
                                                columns={this.columns3}
                                            />

                                        </div></div>
                                </div>

                            </CardBody>

                        </Card>
                    </Col>
                </>
            </div>

        )
    }
}